import { defineMessages } from 'react-intl';

export default defineMessages({
    baAccountHolderContactInfo: {
        id: 'quoteandbind.ba.views.ba-additional-information.Account Holder Contact Info',
        defaultMessage: 'Account Holder Contact Info',
    },
    baDriver: {
        id: 'quoteandbind.ba.views.ba-additional-information.Driver',
        defaultMessage: 'Driver',
    },
    baDriverName: {
        id: 'quoteandbind.ba.views.ba-driver-details.Name',
        defaultMessage: 'Name',
    },
    baLicenseNumber: {
        id: 'quoteandbind.ba.views.ba-additional-information.License Number',
        defaultMessage: 'License Number',
    },
    baVehicle: {
        id: 'quoteandbind.ba.views.ba-additional-information.Vehicle',
        defaultMessage: 'Vehicle',
    },
    baCostNew: {
        id: 'quoteandbind.ba.views.ba-additional-information.Purchase price',
        defaultMessage: 'Purchase price',
    },
    baUseOfVehicle: {
        id: 'quoteandbind.ba.views.ba-policy-info.Use of Vehicle',
        defaultMessage: 'Use of Vehicle',
    },
    baCDistanceDriven: {
        id: 'quoteandbind.ba.views.ba-additional-information.Distance Driven',
        defaultMessage: 'Distance Driven',
    },
    baVin: {
        id: 'quoteandbind.ba.views.ba-additional-information.VIN',
        defaultMessage: 'VIN',
    }
});
